export default {
    en: {
        id: 'exercise3',
        answers: [
            {
                title: `<div class="box-title">Unisys mainframe becoming obsolete</div>
                      <div>
                        - Able to support CIF and Deposit systems for only 3-4 more years
                      </div>`,
                answer: 1,
                hasArrow: true
            },
            {
                title: `<div class="box-title">In danger of being put at competitive disadvantage</div>`,
                answer: 2,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Change approach to technology delivery</div>
                      <div>
                        - Upgrade
                      </div>
                      <div>
                        - Migrate
                      </div>
                      <div>
                        - Outsource
                      </div>`,
                answer: 4,
                hasArrow: true
            },
            {
                title: `<div class="box-title">Remain competitive in the marketplace</div>`,
                answer: 3,
                hasArrow: true
            }
        ],
        image: 'section-5b-3.png'
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5b/practiceDefiningProblem/i18n/exercise3.js